export const checksums = {
  "content": "v3.5.0--Hg1x2gEoD_xnNIKnhu1JhQqEK0tzJ6gbamoNBiM61U0"
}
export const checksumsStructure = {
  "content": "wdfsIA-DtnUUPzQOOBFTOdMf8UXTBF6P78eId39CuH8"
}

export const tables = {
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "dateModified": "string",
      "datePublished": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}